export const GET_WORK_STATUS_QUERY = `
  query GetWorkStatus($where: work_status_bool_exp = {}) {
    work_status(where: $where, order_by: { created_at: desc }) {
      id
      name
      description
      status
      company_id
      company {
        id
        name
      }
      created_at
      updated_at
    }
  }
`;

export const GET_WORK_STATUS_BY_ID_QUERY = `
  query GetWorkStatusById($id: Int!) {
    work_status_by_pk(id: $id) {
      id
      name
      description
      status
      company_id
      company {
        id
        name
      }
      created_at
      updated_at
    }
  }
`; 